import { NavItem } from '../full/vertical/sidebar/nav-item/nav-item';
import { pharmacyComparador } from './pharmacy.menu';

// ============================================================================
//  Menú del rol WarehouseManager ("Almacén"): opera el Almacén principal,
//  sus compras (sin cuentas por pagar), traspasos y la carga de medicamentos a
//  hospitalizaciones.
// ============================================================================

// --- Compras de almacén (sólo documentos de la bodega Almacén) ---------------
export const warehouseCompras: NavItem = {
  displayName: 'Compras',
  iconName: 'truck-delivery',
  route: 'compras-almacen',
  children: [
    { displayName: 'Órdenes por autorizar', iconName: 'point', route: '/almacen/ordenes-por-autorizar' },
    { displayName: 'Órdenes de compra', iconName: 'point', route: '/almacen/ordenes-de-compra' },
    { displayName: 'Recepciones', iconName: 'point', route: '/almacen/recepciones' },
    { displayName: 'Devoluciones a proveedor', iconName: 'point', route: '/almacen/devoluciones-a-proveedor' },
  ],
};

export const navItemsWarehouse: NavItem[] = [
  { navCap: 'Almacén' },
  {
    displayName: 'Inventario',
    iconName: 'building-warehouse',
    route: 'inventario-almacen',
    children: [
      { displayName: 'Productos', iconName: 'point', route: '/inventario/productos' },
      { displayName: 'Lotes y caducidades', iconName: 'point', route: '/inventario/lotes' },
      { displayName: 'Traspasos', iconName: 'point', route: '/inventario/traspasos' },
      { displayName: 'Kardex', iconName: 'point', route: '/inventario/kardex' },
    ],
  },
  warehouseCompras,
  pharmacyComparador,
  {
    displayName: 'Stock bajo',
    iconName: 'chart-bar',
    route: '/farmacia/reportes',
  },

  { navCap: 'Hospital' },
  {
    displayName: 'Hospitalizaciones',
    iconName: 'bed',
    route: '/administracion/hospitalizaciones',
  },
];
